var map = {
	"./2021/Registration/Index.vue": 60964,
	"./2022/Registration/Index.vue": 13037,
	"./2023/Registration/Index.vue": 32825,
	"./2024/Registration/Index.vue": 35852,
	"./2025/Registration/Index.vue": 29040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85904;